import type { IContainer, IPhoto, IPhotoCrop } from '../../common/types/index.js';

function centerCrop(
    crop: IPhotoCrop,
    newWidth: number,
    newHeight: number,
): { x: number; y: number } {
    const x = Math.max(0, crop.x - Math.round(Math.abs(crop.width - newWidth) / 2));
    const y = Math.max(0, crop.y - Math.round(Math.abs(crop.height - newHeight) / 2));

    return { x, y };
}

export function fitCropToContainer(crop: IPhotoCrop, container: IContainer, photo: IPhoto): IPhotoCrop {
    const cropAspectRatio = crop.width / crop.height;
    const containerAspectRatio = container.width / container.height;

    const newCrop = { ...crop };

    if (cropAspectRatio > containerAspectRatio) {
        newCrop.height = Math.round(Math.min(photo.height, newCrop.width / containerAspectRatio));
        newCrop.width = Math.round(newCrop.height * containerAspectRatio);

        const { x, y } = centerCrop(crop, newCrop.width, newCrop.height);

        newCrop.x = x;
        newCrop.y = y;
    } else if (cropAspectRatio < containerAspectRatio) {
        newCrop.width = Math.round(Math.min(photo.width, newCrop.height * containerAspectRatio));
        newCrop.height = Math.round(newCrop.width / containerAspectRatio);

        const { x, y } = centerCrop(crop, newCrop.width, newCrop.height);

        newCrop.x = x;
        newCrop.y = y;
    }

    return newCrop;
}
